var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page",class:_vm.pageClass},[_c('div',{staticClass:"nosto_page_type",staticStyle:{"display":"none"}},[_vm._v("\n    front\n  ")]),_vm._v(" "),_c('page-content',{attrs:{"page":_vm.page}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }